/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["not-found-page{display:flex;justify-content:center;align-items:center;width:100%;height:100%;color:#b0bec5}not-found-page>h1{font-size:9rem;font-weight:300}"];
export { styles as styles };
